export default __webpack_public_path__ + "static/media/thumbs-down-b.f31da10d.svg";